import PoliticalAffiliationsZonesModalView from "./political_affiliations_zones-modal.html";

import toastr from 'toastr';

angular.module("political_affiliations")

    .controller("PoliticalAffiliationsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', '$filter', '$q', '$http', 'gridService', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, $filter, $q, $http, gridService, logService) {
        //Comprobamos si tiene permiso escritura        
        $scope.allowWrite = LoginService.permissionExist("POLITICAL_AFILIATION_WRITE");

        $rootScope.title = $filter('translate')('political_affiliations.title');

        $scope.political_affiliation_id = $stateParams.id;        

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {            
           $rootScope.breadcrumb = [
                { title: $filter('translate')('political_affiliations.title'), url: "political_affiliations.list" },
                { title: $filter('translate')('political_affiliations.title_add'), url: "political_affiliations.edit()" },
            ];            
            $scope.political_affiliation = { };
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('political_affiliations.title'), url: "political_affiliations.list" },
                { title: $filter('translate')('political_affiliations.title_edit'), url: "political_affiliations.edit({ id: " + $stateParams.id + " })" },
            ];

            Restangular.one('PoliticalAffiliations', $stateParams.id).get().then(function (results) {
                $scope.political_affiliation = results;
            });


            $scope.gridZonesPolitical = {
                pdfTitle: $filter('translate')('political_affiliations.zones'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'name', displayName: $filter('translate')('political_affiliations.zone_name'), enableFiltering: true, enableHiding: false,
                        cellTemplate: '<div class="ui-grid-cell-contents"><span style="background-color: {{row.entity.color}}">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;{{row.entity.name}}</div>'
                    },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('political_affiliations.button_edit'), action: 'ng-click="grid.appScope.editZoneDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('political_affiliations.button_delete'), action: 'ng-click="grid.appScope.deleteZoneDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    }
                ],
                getData: function (options) {

                    var deferred = $q.defer();
                    options.political_affiliation_id = $stateParams.id;
                    $http({
                        method: 'get',
                        url: (window as any).CONFIG.api_url + 'PoliticalAffiliations/Zones',
                        params: options
                    }).then(function (results, status, headers, config) {
                        var data = results.data.rows;
                        data.totalRows = results.data.totalRows;
                        $scope.totalRows = results.data.totalRows;
                        deferred.resolve(data);
                    });
                    return deferred.promise;
                }
            };

        }
                                       
        $scope.save = function (frmPoliticalAffiliations) {
                                                            
            if (!angular.isUndefined($scope.political_affiliation_id) && $scope.political_affiliation_id != "") {                
                $scope.political_affiliation.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('political_affiliations.edit_success'));
                        $state.go("political_affiliations.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('PoliticalAffiliations').post($scope.political_affiliation).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('political_affiliations.create_success'));
                        $state.go("political_affiliations.edit", { id: result.id });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('political_affiliations.delete'),
                message: $filter('translate')('political_affiliations.delete_message')+" " + $scope.political_affiliation.name + "?",
                onAccept: function () {
                    $scope.political_affiliation.remove().then(function () {
                        toastr.success($filter('translate')('political_affiliations.delete_success'));
                        $state.go("political_affiliations.list");
                    });
                }
            });
        };      

        $scope.selectImage = function () {
            $("#frmImage").trigger("click");
            $("#frmImage").change(function () {
                const fileInput = document.querySelector('#frmImage') as HTMLInputElement;
                const file = fileInput?.files?.[0];
                if (file) {
                    const fileReader = new FileReader();
                    fileReader.onload = function (event) {
                        const uri = (event.target as FileReader).result;
                        if (angular.isUndefined($scope.political_affiliation.FK_political_affiliations_images) || $scope.political_affiliation.FK_political_affiliations_images == null) $scope.political_affiliation.FK_political_affiliations_images = {};
                        $scope.political_affiliation.FK_political_affiliations_images.image = uri;
                        $scope.political_affiliation.photo = uri;
                        $scope.political_affiliation.image_id = null; //??
                        if (!$scope.$$phase) $scope.$apply();
                    };
                    fileReader.readAsDataURL(file);
                } else {
                    //preview.src = "";
                }
            });
        };

        $scope.getImage = function () {
            if (typeof ($scope.political_affiliation) !== "undefined" && $scope.political_affiliation.FK_political_affiliations_images != null && $scope.political_affiliation.FK_political_affiliations_images.image != null) {
                return $scope.political_affiliation.FK_political_affiliations_images.image;
            } else if (typeof ($scope.political_affiliation) !== "undefined" && $scope.political_affiliation.image_id != null) {
                return "/api/Image/GetImageBmp?id=" + $scope.political_affiliation.image_id + "&maxW=150&maxH2=150";
            } else {
                return "assets/img/no-image.png";
            }
        };

        $scope.removeImage = function ($event) {
            $scope.political_affiliation.image_id = null;
            $scope.political_affiliation.photo = null;
            if ($scope.political_affiliation.FK_political_affiliations_images != null) $scope.political_affiliation.FK_political_affiliations_images.image = null;
            if (typeof ($event) !== "undefined") {
                $event.preventDefault();
                $event.stopPropagation();
            }
        };

        $scope.deleteZoneDialog = function (id, name) {
            modalService.confirm({
                title: $filter('translate')('political_affiliations.delete_zone'),
                message: $filter('translate')('political_affiliations.delete_zone_message') + " " + name + "?",
                onAccept: function () {
                    let options = { id: id }
                    $http({
                        method: 'get',
                        url: (window as any).CONFIG.api_url + 'PoliticalAffiliations/DeleteZone',
                        params: options
                    }).then(function (results, status, headers, config) {
                        toastr.success($filter('translate')('political_affiliations.delete_zone_success'));
                        $scope.gridZonesPolitical.gridApi.core.raise.itemDeleted($scope);

                    });
                }
            });
        };

        $scope.editZoneDialog = function (id) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: PoliticalAffiliationsZonesModalView,
                size: "md",
                controller: "PoliticalAffiliationsModalCtrl",
                resolve: {
                    political_affiliation_zone_id: function () {
                        return id;
                    },
                    political_affiliation_id: function () {
                        return $stateParams.id
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (option) {
                $scope.gridZonesPolitical.gridApi.core.raise.itemChanged($scope);
            });
        };

    }])

    .controller("PoliticalAffiliationsModalCtrl", ['political_affiliation_zone_id', 'political_affiliation_id', '$scope', '$uibModalInstance', 'Restangular', '$http', 'modalService', 'LoginService', '$stateParams', '$filter', 'logService',
        function (political_affiliation_zone_id, political_affiliation_id, $scope, $uibModalInstance, Restangular, $http, modalService, LoginService, $stateParams, $filter, logService) {

        $scope.allowWrite = LoginService.permissionExist("POLITICAL_AFILIATION_WRITE");

        logService.debug(political_affiliation_zone_id);
        if (typeof (political_affiliation_zone_id) === "undefined" || political_affiliation_zone_id == null) {
            $scope.political_affiliation = { political_affiliation_id: political_affiliation_id };
        } else {
            Restangular.all("PoliticalAffiliations").customGET("GetZone", { id: political_affiliation_zone_id }).then(function (result) {
                $scope.political_affiliation = result;
            });
        }
        

        $scope.zones_availables = [];
        let options = { name: "" };
        $http({
            method: 'get',
            url: (window as any).CONFIG.api_url + 'PoliticalAffiliations/ZonesAvailables',
            params: options
        }).then(function (results, status, headers, config) {
            $scope.zones_availables = results.data.rows;
            $scope.zones_availables.unshift({
                id: -1,
                name: "-- " + $filter('translate')('political_affiliations.new_zone_option') + " --"
            }); 
        });

        $scope.callbackClose = function (mode) {
            $uibModalInstance.dismiss(mode);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.save = function () {
            logService.debug($scope.political_affiliation);
            Restangular.all("PoliticalAffiliations").customPOST($scope.political_affiliation, "SaveZone", {}).then(function (results) {
                toastr.success($filter('translate')('political_affiliations.save_zone_success'));
                $uibModalInstance.close();
            });           
        }

    }])

;

